import React from 'react';

const STEP_LABELS = {
  choose: '1. Choose',
  prepare: '2. Prepare',
  review: '3. Review',
  import: '4. Import',
};

export default function StepIndicator({ step, steps }) {
  const currentIndex = steps.indexOf(step);

  return (
    <div className="flex items-center gap-1.5 text-sm">
      {steps.map((s, i) => (
        <React.Fragment key={s}>
          {i > 0 && (
            <div
              className={`w-4 sm:w-6 h-px ${
                currentIndex > i ? 'bg-white/50' : 'bg-white/20'
              }`}
            />
          )}
          <div
            className={`px-2 sm:px-3 py-1 rounded-full text-xs font-medium transition-colors whitespace-nowrap ${
              step === s
                ? 'bg-white text-mv-800'
                : currentIndex > i
                ? 'bg-white/30 text-white'
                : 'bg-white/10 text-white/50'
            }`}
          >
            {STEP_LABELS[s] ?? s}
          </div>
        </React.Fragment>
      ))}
    </div>
  );
}
